import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/globals.css'
import { initializeAuthOnAppStart, startSessionRecovery } from './stores/authStore'

// Initialize auth when app loads
initializeAuthOnAppStart().then(() => {
  // Start periodic session recovery
  startSessionRecovery()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
